const PREFIX = 'FILE'

export const FILE_IMAGE_ADD = `${PREFIX}_IMAGE_ADD`
export const FILE_IMAGE_ADD_ERROR = `${PREFIX}_IMAGE_ADD_ERROR`
